import { TeamMemberNode, MemberDetailNode } from 'nicehubs-plus/es/business/typings';

export type ContactV2 = TeamMemberNode
export type ContactMemberV2 = MemberDetailNode

// 常用联系人
export interface Contact {
  commonCompany: boolean;
  userId: string;
  remark: string;
  memberName:string
  from: number;
  person: Person;
  createTime: number;
  relation: Relation;
  jobTitle:string;
  department: string,
  orgName:string
  refId:string
}

// 好友关系类型
export enum Relation {
  // 相关添加
  EACH_ADDED = 1,
  // 单边添加
  ONE_SIDED_ADDED = 2,
  // 非好友
  NONE = 3
}

export interface Person {
  displayName: string;
  name: string;
  memberName?: string;
  realName: string;
  realname?: string;
  department: string;
  staffId: string;
  personStaffId: string;
  company: string;
  companyName: string;
  createTime: number;
  avatar: string;
  jobTitle: string;
  mobile: string;
  id: string;
  companyId: string;
  email: string;
  remark: string;
  relation?: Relation;
  commonCompany?: boolean;
  _id?: string;
  type?: string;
  refId?: string;
  userId?: string;
  orgId:string
  cardPhoto?: string;
  teamQualifiedName?: string;
  teamName?: string;
}

// 标签
export interface Label {
  id: number;
  updatedDate: number;
  createdDate: number;
  name: string;
  staffId: string;
  num: number;
}

// 标签员工
export interface LabelStaff {
  id: number;
  createdDate: number;
  staffId: string;
  ownerId: string;
  labelId: number;
  updatedDate: number;
}

// 员工标签
export interface StaffLabel {
  id: number;
  createdDate: number;
  staffId: string;
  updatedDate: number;
  name: string
}

export interface LabelList extends Label {
  contact: Contact[]
}

// 搜索联系人
export interface searchContact {
  contactPersons: Person[]
  searchId: string
  userId: string
}

// 字母排序后的联系人

export interface letterPerson {
  firstLetter: string
  person: Person[]
};
